Controller.$inject = ['$element'];

function Controller($element) {
    const self = this;
    
    self.$onInit = function() {
        applyClamp();
    };
    
    self.$onChanges = function(changes) {
        if (changes.textClamp) {
            applyClamp();
        }
    };
    
    function applyClamp() {
        const element = $element[0];
        
        if (self.textClamp) {
            const lineCount = typeof self.textClamp === 'string' ? parseInt(self.textClamp, 10) : self.textClamp;
            
            if (!isNaN(lineCount) && lineCount > 0) {
                element.classList.add('text-clamp');
                element.style.setProperty('--line-clamp', lineCount.toString());
            }
        }
    }
}

export function TextClamp() {
    return {
        restrict: 'A',
        scope: false,
        bindToController: {
            textClamp: '@'
        },
        controller: Controller,
        controllerAs: '$textClampCtrl'
    };
}

